import { dataHook } from '../../utils'
// @ts-ignore
import classes from './button.css'

const buttonTemplate = (
  modifier: string,
  body: string,
  hook: string,
  ariaLabel?: string,
) =>
  `<button class="${classes.button} ${modifier}" ${dataHook(hook)} ${
    ariaLabel || ''
  }>${body}</button>`

export const primaryButtonTemplate = (
  body: string,
  customHook = '',
  ariaLabel?: string,
) => buttonTemplate(classes.primary, body, customHook, ariaLabel)

export const secondaryButtonTemplate = (
  body: string,
  customHook = '',
  ariaLabel?: string,
) => buttonTemplate(classes.secondary, body, customHook, ariaLabel)
